import { useState, useEffect } from "react";
import { TextField, Typography } from "@material-ui/core";
import StandardModal from "./StandardModal";
import ModalSize from "./ModalSize";
import FirebaseService from "../../services/firebase/FirebaseService";
import { useAssignmentModalState } from "./modalHooks";
import LoadingButton from "../Loading/LoadingButton";

interface ShareAssignmentModalProps {
  open: boolean;
  cancelClose: () => void;
}
const ShareAssignmentModal = (props: ShareAssignmentModalProps) => {
  const { enqueueSnackbar, assignment } = useAssignmentModalState();
  const [recipientEmail, setRecipientEmail] = useState("");
  const [loadingButtonState, setButtonState] = useState(LoadingButton.BeforeLoading);

  const shareAssignment = async () => {
    setButtonState(LoadingButton.Loading);
    if (!assignment) return;
    try {
      const { result, msg } = await FirebaseService.shareAssignment(assignment.id, recipientEmail);
      enqueueSnackbar(msg, result ? "success" : "error");
    } catch (e) {
      enqueueSnackbar("Could not share this assignment", "error");
    }
    props.cancelClose();
    setButtonState(LoadingButton.BeforeLoading);
  };

  useEffect(() => {
    setButtonState(LoadingButton.BeforeLoading);
    setRecipientEmail("");
  }, [assignment, props.open]);

  return (
    <StandardModal
      title="Share Assignment with Teacher"
      size={ModalSize.medium}
      submitButtonText="Share"
      onSubmit={shareAssignment}
      loadingButtonState={loadingButtonState}
      changeLoadingButtonState={setButtonState}
      {...props}
    >
      <Typography variant="subtitle1">
        New teachers won’t see your student data but will be able to assign the text to their own students.
      </Typography>
      <TextField
        value={recipientEmail}
        variant="outlined"
        onChange={({ target }) => setRecipientEmail(target.value)}
        fullWidth
        label="Teacher's email"
        style={{ marginTop: 16 }}
      />
    </StandardModal>
  );
};

export default ShareAssignmentModal;
